import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import * as api from "../../api";
import SupplierInvoiceTableHeader from "./supplier-invoice-table-header";
import SupplierInvoiceTableRow from "./supplier-invoice-table-row";
import ArrayDataProvider from "../../components/table/data-providers/array-data-provider";
import FilterableDatatable from "../../components/table/filterable-data-table";

export default class SupplierInvoiceDetails extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            dataProvider: new ArrayDataProvider([], ["chargeType"])
        }
    }

    componentDidMount = () => {
        this.fetchData();
    };

    fetchData = () => {
        api.getSupplierInvoiceDetails(this.props.supplierInvoiceKey)
            .then(this.state.dataProvider.updateDataSource);
    };

    render() {
        return (
            <FilterableDatatable dataProvider={this.state.dataProvider} name="supplier-invoice-details"
                                 refreshDataTrigger={this.state.dataProvider.onDataSourceChanged}
                                 headerComponent={SupplierInvoiceTableHeader} rowComponent={SupplierInvoiceTableRow} />
        );
    }
}